import React, {useEffect}  from 'react';
import NextButton from '../nextButton';
import finik from './images/finik3_col_e.png';

import './style.css';

const Rebus = ({ onNextLevel, messNext, answer, setAnswer, img }) => {
	const imgRef = React.createRef();

	useEffect(()=>{
		// if(e.target.value ==='') {
			const ifin = imgRef.current;

			ifin.classList.add('finik-bl3_anistart');

		setTimeout( ()=> {
		ifin.classList.remove('finik-bl3_anistart');

	}, 500);
},[]);

	return ( 
		<div className="section">
			<div className="container">
				<div className="head">отгадай ребус</div>
				<div className="wrapper _2">
					<div className="head mobile">отгадай ребус</div>
					<div className="top-box _2">
						<div className="img-rebus-box"
							style={{backgroundImage: `url(${img})` }}></div>
						<div className="ball"></div>
						<img ref={imgRef} src={finik} loading="lazy" alt="" 
									className="finik-bl3 finik-bl3_anistart"/>
					</div>
					<div className="bottom-box">
						<div className="input-box">
							<div className="text-block">Впиши получившееся <span className="text-span">слово</span> в поле</div>
							<input autoFocus ref={input => input && input.focus()} value={answer} onChange={(e)=>setAnswer(e.target.value)} className="input-q" />
						</div>
							<NextButton classes="button-q w-button" onNextLevel={onNextLevel} messNext={messNext} />
						</div>
				</div>
			</div>
		</div>
  );
}

export default Rebus;
